import { render, staticRenderFns } from "./CopyrightSearch.vue?vue&type=template&id=58e3966e&scoped=true&"
import script from "./CopyrightSearch.vue?vue&type=script&lang=js&"
export * from "./CopyrightSearch.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightSearch.vue?vue&type=style&index=0&id=58e3966e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e3966e",
  null
  
)

export default component.exports